export const calculateGap = (playersCount: number) => {
  if (playersCount === 2) {
    return 77;
  } else if (playersCount === 3) {
    return 28;
  } else {
    return 5;
  }
};
